import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../../store/SelectionSliceFor';

const entityKey = 'deployment-account-groups';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const DeploymentAccountGroupsReducer = combineReducers({
    selection: selectionSlice.reducer,
});
